"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosLocationCategorySaveInputSchema = exports.APosLocationCategorySaveCategoryInputSchema = exports.APosLocationCategorySchema = exports.APosLocationCategoryPromotionOverrideSchema = exports.APosLocationCategoryComplianceOverrideSchema = exports.APosLocationCategoryChannelConfigSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
// Per-channel configuration (Tax, Fees, Compliance, Promotions per channel)
exports.APosLocationCategoryChannelConfigSchema = zod_1.z.object({
    taxIds: zod_1.z.array(zod_1.z.string()).default([]),
    feeIds: zod_1.z.array(zod_1.z.string()).default([]),
    compliancePresetId: zod_1.z.string().optional(),
    promotionId: zod_1.z.string().optional(),
    commissionId: zod_1.z.string().optional(),
    cashDiscountId: zod_1.z.string().optional(), // Retail only
    pricingModelId: zod_1.z.string().optional(),
}).optional();
// Compliance override (kept — separate from tax/fee)
exports.APosLocationCategoryComplianceOverrideSchema = zod_1.z.object({
    mode: zod_1.z.enum(['preset', 'custom']),
    presetId: zod_1.z.string().optional(),
    ageRestrictionType: zod_1.z.enum(['none', '18+', '21+', 'custom']).optional(),
    ageRestrictionMinAge: zod_1.z.number().int().min(0).max(100).optional(),
    maxPerTransaction: zod_1.z.number().int().min(0).optional(),
    dailyPurchaseLimit: zod_1.z.number().int().min(0).optional(),
    weeklyPurchaseLimit: zod_1.z.number().int().min(0).optional(),
    purchaseLimitUnit: zod_1.z.string().optional(),
    customerRegistrationRequired: zod_1.z.boolean().optional(),
    membershipRequired: zod_1.z.boolean().optional(),
    requiredMembershipPlanId: zod_1.z.string().optional(),
}).optional();
// Promotion override (kept — separate from tax/fee)
exports.APosLocationCategoryPromotionOverrideSchema = zod_1.z.object({
    mode: zod_1.z.enum(['all', 'allowlist', 'blocklist']),
    promotionIds: zod_1.z.array(zod_1.z.string()).optional(),
}).optional();
// Full entity
exports.APosLocationCategorySchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    locationCategoryKey: zod_1.z.string().min(1),
    locationId: zod_1.z.string().min(1),
    categoryId: zod_1.z.string().min(1),
    categoryName: zod_1.z.string().min(1).max(200),
    isAllowed: zod_1.z.boolean().default(true),
    channelConfigs: zod_1.z.object({
        retail: exports.APosLocationCategoryChannelConfigSchema,
        online: exports.APosLocationCategoryChannelConfigSchema,
        b2b: exports.APosLocationCategoryChannelConfigSchema,
    }).optional(),
    complianceOverride: exports.APosLocationCategoryComplianceOverrideSchema,
    promotionOverrides: exports.APosLocationCategoryPromotionOverrideSchema,
}).merge(timestamps_schema_1.TimestampsSchema);
// Save input
exports.APosLocationCategorySaveCategoryInputSchema = zod_1.z.object({
    categoryId: zod_1.z.string().min(1),
    categoryName: zod_1.z.string().min(1).max(200).optional(),
    isAllowed: zod_1.z.boolean().default(true),
    channelConfigs: zod_1.z.object({
        retail: exports.APosLocationCategoryChannelConfigSchema,
        online: exports.APosLocationCategoryChannelConfigSchema,
        b2b: exports.APosLocationCategoryChannelConfigSchema,
    }).optional(),
    complianceOverride: exports.APosLocationCategoryComplianceOverrideSchema,
    promotionOverrides: exports.APosLocationCategoryPromotionOverrideSchema,
});
exports.APosLocationCategorySaveInputSchema = zod_1.z.object({
    mode: zod_1.z.enum(['all', 'selected']),
    categories: zod_1.z.array(exports.APosLocationCategorySaveCategoryInputSchema).optional(),
});
//# sourceMappingURL=location-category.schema.js.map